import { createFileRoute } from '@tanstack/react-router';
import { Header, Footer } from '@/components/marketing';
import { PricingSection } from '@/components/marketing/PricingSection';
import { MinimalCTA } from '@/components/marketing/CTASection';

export const Route = createFileRoute('/pricing')({
  component: PricingPage,
});

function PricingPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1 pt-16">
        <PricingSection />
        <MinimalCTA />
      </main>
      <Footer />
    </div>
  );
}
